import axios from 'axios'
import React, { useEffect, useState } from 'react'
import { baseUrl } from '../../baseUrl'
import { Link, useParams } from 'react-router-dom'
import style from '../admin/exam/ExamResult.module.css'
import { useAuth } from '../../AuthContext'

const ResultTWP = () => {
  const { user } = useAuth()
  const params = useParams()
  const [result, setResult] = useState([])
  const [loading,setLoading]=useState(false)
  useEffect(() => {
    axios.get(`${baseUrl}/dynamic-exam/result?examId=${params.examId}`)
    .then(res=>{setResult(res.data);setLoading(false)})
    .catch(err=>{console.log(err);setLoading(false)})
  }, [])
  return (
    <div className='d-flex justify-content-center'>
      {
        !loading&&result&&result.result?
        <div className='' >
          <h4 className=' mt-5'>Exam Result</h4>
          <h5 className={` ${result.result.color === 'green' ? 'text-success' : result.result.color === 'yellow' ? 'text-warning' : 'text-danger'}`}>{result.result.status}</h5>
          <p>{result.result.message}</p>
          <p>Score : {result.score} out of {result.totalMarks} ({result.result.percentage}%)</p>
          <p>Total Questions : {(result.attemptedQuestions+result.unattemptedQuestions)}</p>
          <p>Attempted : {result.attemptedQuestions} Unattempted : {result.unattemptedQuestions}</p>

          {result.result.topicResults ? (
            <div>
              <h5>Subject-wise Analysis</h5>
              {result.result.topicResults.map((topic, index) => (
                <div key={index} className="mb-3 p-3 border rounded">
                  <h6 className={` ${topic.color === 'green' ? 'text-success' : topic.color === 'yellow' ? 'text-warning' : 'text-danger'}`}>({topic.subject}): {topic.status}</h6>
                  <p>{topic.message}</p>
                  <p>Score: {topic.score} out of {topic.totalQuestions * 4} ({topic.percentage}%)</p>
                  <p>Correct: {topic.correct} | Incorrect: {topic.incorrect} | Attempted: {topic.attempted} | Unattempted: {topic.unattempted}</p>
                </div>
              ))}
            </div>
          ) : (
            <table className={`${style.table}`}>
              <thead>
                <tr>
                  <th>Question Analysis<br></br><span className={`${style.qaSpan}`}>( correct | incorrect | left )</span></th>
                  <th rowspan="2">Total Marks<br></br><span style={{ fontWeight: '400' }}>{result.totalMarks}</span></th>
                </tr>
              </thead>

              <tbody>
                <tr>
                  <td>{result.correct} | {result.incorrect} | {result.unattemptedQuestions}</td>
                  <td>{result.score}</td>
                </tr>
              </tbody>
            </table>
          )}
          <Link to={`${user ? `/student/${user.email}` : '/'}`}>{user ? 'Back to profile' : 'Back to home'}</Link>
        </div>
            :
            <div>
            <h2>No result captured</h2>
            <Link to={`${user?`/student/${user.email}`:'/'}`}>{user?'Back to profile':'Back to home'}</Link>
            </div>
      }

    </div>
  )
}

export default ResultTWP
